//////////////////////////////////
// IMPORTING MODULES
//////////////////////////////////

import { ChevronDown } from "lucide-react";
import React, { useState } from "react";

//////////////////////////////////
// COMPONENT: FAQ
//////////////////////////////////

const FAQ = (): JSX.Element => {
  const faqs = [
    {
      question: "What is Flight Trail?",
      answer:
        "Flight Trail is an interactive travel tracking application that visualizes your journeys on a beautiful 3D globe. Add airports you've visited, view travel statistics, and explore your global adventures with stunning visualizations.",
    },
    {
      question: "Is Flight Trail free to use?",
      answer:
        "Yes! Flight Trail offers a free tier that includes all core features: unlimited airport tracking, 3D globe visualization, travel statistics, and cloud storage. Premium features may be added in the future.",
    },
    {
      question: "How do I add airports to my map?",
      answer:
        "Simply use the search feature to find any airport by name, city, or IATA code. Click to add it to your travel history. You can also add visit dates, aircraft types, and personal notes for each airport.",
    },
    {
      question: "Can I access my data on multiple devices?",
      answer:
        "Absolutely! Your data is securely stored in the cloud and automatically syncs across all your devices. Access your travel map from your phone, or tablet. We are looking to have a web version of the app.",
    },
  ];
  const [openFAQ, setOpenFAQ] = useState<number | null>(null);

  const toggleFAQ = (index: number) => {
    setOpenFAQ(openFAQ === index ? null : index);
  };
  return (
    <section id="faq" className="py-20">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold mb-4 px-10">
            Frequently Asked Questions
          </h2>
          <p className="text-xl text-gray-400 px-10">
            Everything you need to know about Flight Trail
          </p>
        </div>

        <div className="space-y-4 px-10">
          {faqs.map((faq, index) => (
            <div key={index} className="border-b border-gray-800">
              <button
                onClick={() => toggleFAQ(index)}
                className="w-full text-left py-6 flex justify-between items-center"
              >
                <span className="text-lg font-semibold">{faq.question}</span>
                <ChevronDown
                  className={`w-6 h-6 text-[#2ab8ff] transition-transform ${
                    openFAQ === index ? "rotate-180" : ""
                  }`}
                />
              </button>
              <div
                style={{
                  maxHeight: openFAQ === index ? "500px" : "0",
                  overflow: "hidden",
                  transition: "max-height 0.3s ease",
                }}
              >
                <p className="text-gray-400 pb-6">{faq.answer}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

//////////////////////////////////
// EXPORTING FAQ
//////////////////////////////////

export default FAQ;
